// extracted by mini-css-extract-plugin
export default {"promo":"PromoCodeInput-module--promo--4c4c9","message":"PromoCodeInput-module--message--02338","valid":"PromoCodeInput-module--valid--5bf75"};